// @flow
import { APP_DNEVNIK } from 'app/common/constants/services';
import * as orgsTypes from 'app/common/constants/schools/types';


const getAppTranslateIdWithPrefix = (currentOrgType: $Values<typeof orgsTypes>, app: string) => {
  if (currentOrgType === orgsTypes.HIGH_SCHOOL && app === APP_DNEVNIK) {
    return `high_school_${app}`;
  }
  return app;
};

export default getAppTranslateIdWithPrefix;
